import { render, staticRenderFns } from "./MailEditor.vue?vue&type=template&id=58e865d4&"
import script from "./MailEditor.vue?vue&type=script&lang=js&"
export * from "./MailEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports